import React, { useState } from "react";
import {
  Box,
  Paper,
  Tabs,
  Tab,
  Typography,
} from "@mui/material";
import AMCLogoManager from "../../components/MutualFunds/AMCLogoManager";
import FundOfferDocuments from "../../components/MutualFunds/FundOfferDocuments";
import SmestRecommends from "../../components/MutualFunds/SmestRecommends";

const TAB_OPTIONS = [
  {
    label: "AMC Logos",
    component: <AMCLogoManager />,
  },
  {
    label: "Fund Offer Documents",
    component: <FundOfferDocuments />,
  },
  {
    label: "SMEST Recommends",
    component: <SmestRecommends />,
  },
];

const MutualFundMaster = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box p={3}>
      <Paper elevation={3} sx={{ borderRadius: 3, overflow: "hidden" }}>
        <Box
          sx={{
            background: "#262349",
            color: "#fff",
            p: 3,
          }}
        >
          <Typography variant="h4" fontWeight={600}>
            Mutual Fund Master
          </Typography>
        </Box>

        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            borderBottom: "1px solid #e0e0e0",
            px: 2,

            "& .MuiTab-root": {
              minHeight: 64,
              textTransform: "none",
              fontWeight: 600,
              color: "#666",
            },

            "& .Mui-selected": {
              color: "#262349 !important",
            },

            "& .MuiTabs-indicator": {
              backgroundColor: "#262349", 
              height: 3,
            },
          }}
        >
          {TAB_OPTIONS.map((tab) => (
            <Tab key={tab.label} label={tab.label} />
          ))}
        </Tabs>

        <Box p={3}>
          {TAB_OPTIONS[activeTab].component}
        </Box>
      </Paper>
    </Box>
  );
};

export default MutualFundMaster;